<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{title}}</title>
    <g :fill="fill">
      <path d="M46,17H43V31h3a1,1,0,0,0,1-1V18A1,1,0,0,0,46,17Z"></path>
      <path
        d="M36,10H6a5.006,5.006,0,0,0-5,5V33a5.006,5.006,0,0,0,5,5H36a5.006,5.006,0,0,0,5-5V15A5.006,5.006,0,0,0,36,10ZM30.781,26.625a1,1,0,0,1-1.143.307L22,23.962V30a1,1,0,0,1-1.625.781l-10-8A1,1,0,0,1,10,22a.989.989,0,0,1,.134-.5,1,1,0,0,1,1.228-.433L19,24.038V18a1,1,0,0,1,1.625-.781l10,8A1,1,0,0,1,30.781,26.625Z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "BatteryCharged",
  props: {
    title: {
      default: 'Batterie',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
}
</script>
